import {useId, useState, useEffect} from "react";
import {myDocument} from "../utils";

export const BannerImage = ()=>{
	return (<div className="ske-banner-image flex justify-center items-center rounded-box">
        <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
    </div>)
}

export const Input = (params : any)=>{
	return (<div className={"ske-input "+(params.className ? params.className : "h-12 rounded-md w-auto")}>{params.title ? params.title : params.children ? params.children : ""}</div>)
}

export const Button = (params : any)=>{
	return (<div className={"ske-button "+(params.className ? params.className : "h-12 rounded-md w-auto")}>{params.title ? params.title : params.children ? params.children : ""}</div>)
}

export const HCaptcha = ()=>{
	return (<div className="ske-hcaptcha w-[303px] h-[78px] rounded-md"></div>);
}

export const Link = (params : any)=>{
	return (<a className={"link "+(params.className ? params.className : "")} >{params.title ? params.title : params.children ? params.children : ""}</a>);
}

export const Label = (params : any)=>{
	return (
		<label className={"label "+(params.className ? params.className : "")}>{params.title ? params.title : params.children ? params.children : ""}</label>
	);
}

export const RenderSkeleton = (params : any)=>{
	const id = useId();
	const [loading, setLoading] = useState(true);
	const handleLoading = ()=>{
		const skeleton = myDocument.getElementById(`${id}`).querySelector(params.ske ? params.ske : ".skeleton");
		const skeletonPage = myDocument.getElementById(`${id}`).querySelector(params.main ? params.main : ".skeleton--page");
		setTimeout(function(){
		    skeleton && skeleton.remove();
		    skeletonPage && skeletonPage.classList.remove("skeleton--page");
		},params.timeOut ? params.timeOut : 1000);
	}
	return {id:id,  handleLoading: handleLoading};
}